import { render, staticRenderFns } from "./EcocardioDatiList.vue?vue&type=template&id=4b2c0d22"
import script from "./EcocardioDatiList.vue?vue&type=script&lang=js"
export * from "./EcocardioDatiList.vue?vue&type=script&lang=js"
import style0 from "./EcocardioDatiList.vue?vue&type=style&index=0&id=4b2c0d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports